export const meta = {
  id: '46-relative-and-subordinate-clauses',
  order: 46,
  titleFi: 'Relatiivilauseet ja sidesanat',
  titleEn: 'Relative clauses and conjunctions',
  lemmaIds: [
    'lua',
    'lȳ',
    'līr',
    'tyvaros',
    'hoskagon',
    'muñar',
    'mundāzma',
    'imassigon',
    'qēlītsos',
    'hēnka',
    'ubardugon',
    'vapār-2',
    'lodaor',
    'skorȳso',
    'sīlī',
    'korzigon',
    'dāranna',
    'zbērigon',
    'yrgos',
    'tolijī',
    'paghy',
    'jēdun',
    'ours:lettenītsos',
  ],
  exampleIds: [
    'ex-41813fdaae64',
    'ex-e304b2b88b0a',
    'ex-e8f364528fb5',
    'ex-bb0d13e9c7b7',
    'ex-32beba3ab860',
    'ex-5243158f1035',
    'ex-4e92c5cceb75',
    'ex-17d0e4dba360',
    'ex-1097b2be36d2',
    'ex-e06ca061fb10',
    'ex-93fc345af78b',
    'ex-a21911c5c6c3',
    'ex-56af41a285be',
    'ex-1ac36741e3f2',
    'ex-41f60b238f0c',
    'ex-8295f52fa9c2',
    'hotd-s1e05-001',
    'hotd-s1e02-013',
    'hotd-s1e02-014',
    'got-s6e02-002',
    'hotd-s3e03-002',
    'hotd-s1e02-010',
    'ex-3f44463882b3',
    'ex-a70ab1390279',
    'ex-1053034e687f',
    'ex-ed03e5a708fb',
    'ex-dc8bd0596993',
    'ex-f1f5d97ace33',
    'ex-53ecade293a8',
    'hotd-s2e04-006',
    'ex-89c24cc3b71b',
    'ex-a634b9840da5',
    'ex-1a668ab27fbc',
    'ex-df3b8f72326b',
    'hotd-s1e04-004',
    'ex-78b8157db7c6',
    'ex-1d4fc04261b3',
  ],
  sources: [
    'https://wiki.languageinvention.com/index.php?title=High_Valyrian_Grammar',
    'https://wiki.languageinvention.com/index.php?title=User:Najahho/High_Valyrian_Pronouns',
    'https://wiki.languageinvention.com/index.php?title=User:Najahho/High_Valyrian_Verb_Moods',
    'https://wiki.languageinvention.com/index.php?title=Appendix:High_Valyrian_Duolingo_Tips_and_Notes',
    'https://wiki.languageinvention.com/index.php?title=Lua',
    'https://wiki.languageinvention.com/index.php?title=Līr',
    'https://wiki.languageinvention.com/index.php?title=Lȳ',
    'https://wiki.languageinvention.com/index.php?title=Iā',
    'https://wiki.languageinvention.com/index.php?title=Vapār',
    'https://wiki.languageinvention.com/index.php?title=Kesrio_syt',
    'https://wiki.languageinvention.com/index.php?title=Kejo_syt',
    'https://wiki.languageinvention.com/index.php?title=Skorȳso',
    'https://wiki.languageinvention.com/index.php?title=Lodaor',
    'https://wiki.languageinvention.com/index.php?title=Lo',
    'https://wiki.languageinvention.com/index.php?title=Sepār',
    'https://wiki.languageinvention.com/index.php?title=Toliot',
    'https://wiki.languageinvention.com/index.php?title=Pendagon',
    'https://dedalvs.tumblr.com/post/143745488442/high-valyrian-dialogue-episode-602-of-game-of',
  ],
  // the week (docs/COURSE.md "Lesson hub")
  grammar: ['relative', 'subordinate'],
  showLines: ['hotd-s1e05-001', 'hotd-s1e02-013', 'hotd-s1e02-014', 'got-s6e02-002', 'hotd-s3e03-002', 'hotd-s1e02-010', 'hotd-s2e04-006', 'hotd-s1e04-004'],
  pronunciation: { focus: 'rhythm', lines: ['got-s6e02-002'] },
  letter: {
    fi: 'Kirjoita kirje, jossa on relatiivilause ja kaksi sivulausetta (koska, kunnes).',
    en: 'Write a letter with a relative clause and two subordinate clauses (because, until).',
  },
  scene: 'hotd-s1e05-1',
}

# Relatiivilauseet ja sidesanat

Kaksi tapaa rakentaa pidempiä lauseita: relatiivilause (*mies, joka näki tytön*) ja sidesanalla alkava sivulause (*kunnes*, *koska*, *muuten*).

## Relatiivilauseet

Duolingon luonto-osiossa (<LessonLink n={31}>oppitunti 31</LessonLink>) näit pieniä ”määrittäviä lauseita”, kuten <Hv fi="Näin maassa olevan miehen.">Tegot vale ūndan</Hv>, ja osio lupasi, että oikeat relatiivilauseet tulevat myöhemmin. Nyt on niiden vuoro. Relatiivilauseella kuvataan substantiivia kokonaisella lauseella: *mies, joka näki naisen*; *talo, jossa nainen kuoli*; *se, mitä haluat*. Tämän oppitunnin jälkeen pystyt lukemaan Daenerysin ja Rhaenyran pisimmätkin repliikit, koska melkein jokaisessa on tällainen lause.

## Peilikuva suomesta

Suomessa pääsana tulee ensin, sitten pilkku, relatiivipronomini *joka* ja lause. Valyriassa järjestys on päinvastainen: ensin koko lause, sitten <Term id="relatiiviadjektiivi">relatiiviadjektiivi</Term> <Hv>lua</Hv> ja vasta lopuksi pääsana. Wikin kielioppisivun perusesimerkki:

<Example id="ex-41813fdaae64" />

<Interlinear hv="Ābre kustittas lua vala raqiros issa." gloss="nainen-ACC rohkaista-PRF.3SG joka-LUN.NOM mies-NOM ystävä-NOM olla-PRS.3SG" fi="Mies, joka rohkaisi naista, on ystävä." />

Sanatarkasti: *naista rohkaisi joka mies ystävä on*. Wikin kielioppisivun mukaan valyria on vahvasti ”pää lopussa” -kieli: määritteet tulevat ennen pääsanaa. Adjektiivi tulee ennen substantiivia (<Hv fi="iloinen mies">kirine vala</Hv>), genetiivi ennen omistettavaa, ja relatiivilause on vain pisin mahdollinen määrite. <Hv>Lua</Hv> on aina pääsanansa edellä, joten siitä käytetään vain etuaseman muotoja.

<Note>
Suomessa on rakenne, joka toimii täsmälleen samassa järjestyksessä: partisiippimäärite. *Naista rohkaissut mies on ystävä.* Objekti, verbi, pääsana. Kun luet valyrian relatiivilausetta, kokeile kääntää se ensin partisiipilla ja tee siitä *joka*-lause vasta sitten.
</Note>

## Sija tulee päälauseesta

Tämä on oppitunnin tärkein asia, ja suomalaisen näkökulmasta se on nurinkurinen. Suomen *joka* saa sijansa omasta lauseestaan: *mies, **joka** näki*; *mies, **jonka** nainen näki*. Valyrian <Hv>lua</Hv> taas saa sijansa **päälauseesta** eli siitä, mikä pääsanan tehtävä on päälauseessa. Vertaa yllä olevaa lausetta tähän:

<Example id="ex-e304b2b88b0a" />

<Interlinear hv="Ābre kustittas lue vale ūndetan." gloss="nainen-ACC rohkaista-PRF.3SG joka-LUN.ACC mies-ACC nähdä-PRF.1SG" fi="Näin miehen, joka rohkaisi naista." />

Relatiivilause on sama (<Hv fi="(joka) rohkaisi naista">Ābre kustittas</Hv>), mutta mies on nyt päälauseessa objekti, joten sekä <Hv>lue</Hv> että <Hv>vale</Hv> ovat akkusatiivissa. Sen, mikä rooli kullakin on relatiivilauseen sisällä, kertovat relatiivilauseen muut sanat: <Hv>ābre</Hv> on akkusatiivissa, joten nainen on se, jota rohkaistiin, ja mies on tekijä. Jos relatiivilauseessa lukisi <Hv>ābra</Hv> (nominatiivi), nainen olisi tekijä ja mies kohde: *mies, jota nainen rohkaisi*.

Tässäkin suomen partisiippi auttaa: *Näin naista rohkaisseen miehen.* Partisiippi *rohkaisseen* taipuu päälauseen mukaan, aivan kuten <Hv>lue</Hv>.

<Paradigm lemma="lua" numbers="sg,pl" filter="positive.pre" />

Taulukosta näet, että <Hv>lua</Hv> taipuu suunnilleen kuin <Term id="adjektiiviluokka">I-luokan</Term> adjektiivi, mutta muutama muoto on epäsäännöllinen: aurinkosuvun nominatiivi on <Hv l="lua">lȳs</Hv> ja akkusatiivi <Hv l="lua">lī</Hv>, maasuvun <Hv>luon</Hv>.

## Aukko ja selventävä pronomini

Relatiivilauseesta puuttuu se sana, joka sillä on yhteinen päälauseen kanssa: <Hv fi="(joka) rohkaisi naista">Ābre kustittas</Hv> ei kerro, kuka rohkaisi, koska rohkaisija on pääsana <Hv>vala</Hv>. Tämä aukko voi tehdä lauseesta monitulkintaisen, jos relatiivilauseen toinen substantiivi kuuluu <Term id="deklinaatio">taivutusluokkaan</Term>, jossa nominatiivi ja akkusatiivi ovat samat. <Hv glossed>Tyvaros</Hv> ’käärme’ on juuri sellainen. Wikin kielioppisivun esimerkki:

<Interlinear hv="Tyvaros ūndas lua vala raqiros issa." gloss="käärme-NOM/ACC nähdä-PRF.3SG joka-LUN.NOM mies-NOM ystävä-NOM olla-PRS.3SG" fi="Mies, joka näki käärmeen / jonka käärme näki, on ystävä." />

Kun tarkkuutta tarvitaan, relatiivilauseeseen lisätään pronomini, joka viittaa pääsanaan. Sanajärjestys ratkaisee: subjekti ennen objektia.

<Interlinear hv="Tyvaros ziry ūndas lua vala raqiros issa." gloss="käärme-NOM hän-ACC nähdä-PRF.3SG joka-LUN.NOM mies-NOM ystävä-NOM olla-PRS.3SG" fi="Mies, jonka käärme näki, on ystävä." />

Wikin mukaan rakenne toimii lähes missä tahansa roolissa. Pääsana voi olla relatiivilauseessa subjekti, objekti, epäsuora objekti, omistaja, paikka, vertailukohta tai postposition täydennys. Esimerkki omistajasta:

<Example id="ex-e8f364528fb5" />

<Interlinear hv="Ābra kepe rhēdes lua vala raqiros issa." gloss="nainen-NOM isä-ACC tuntea-PRS.3SG joka-LUN.NOM mies-NOM ystävä-NOM olla-PRS.3SG" fi="Mies, jonka isän nainen tuntee, on ystävä." />

Selvyyden vuoksi voi sanoa <Hv glossed>zȳhe kepe</Hv> ’hänen isänsä’. Paikkaa kuvaavassa esimerkissä pääsana on talo, ja selventäjänä toimii <Hv glossed>konīr</Hv> ’siellä’:

<Interlinear hv="Ābra konīr morghūltas luon lenton pryjataks." gloss="nainen-NOM siellä kuolla-PRF.3SG joka-TERR.NOM talo-NOM tuhota-PRF.PASS.3SG" fi="Talo, jossa nainen kuoli, tuhottiin." />

Ilman sanaa <Hv l="konīr">konīr</Hv> lause on <Hv fi="Talo, jossa nainen kuoli, tuhottiin.">Ābra morghūltas luon lenton pryjataks</Hv>, ja <Hv>luon</Hv> vastaa silloin suomen sanaa *jossa*. Seuraavassa esimerkissä on Duolingosta tuttu applikatiivi <Hv glossed>ubardugon</Hv> ’kirjoittaa jonkin päälle’, joten kirja on relatiivilauseessa kohde, johon kirjoitetaan.

<Example id="ex-bb0d13e9c7b7" />

## Daenerys puhuu relatiivilauseilla

Astaporin kohtauksessa (<LessonLink n={49}>oppitunti 49</LessonLink>) Daenerys antaa käskyjä, joissa kaikissa on relatiivilause. Katso, miten <Hv>lua</Hv> vaihtaa muotoaan päälauseen mukaan:

<Example id="ex-32beba3ab860" />

<Interlinear hv="Henujagon jaelza lua vala mirre henujagon kostas." gloss="lähteä-INF haluta-PRS.3SG joka-LUN.NOM mies-NOM kuka.tahansa-LUN.NOM lähteä-INF voida-PRS.3SG" fi="Jokainen mies, joka haluaa lähteä, saa lähteä." />

Mies on päälauseen subjekti, joten käytetään muotoa <Hv>lua</Hv>. Huomaa myös <Hv>mirre</Hv> pääsanan **jäljessä**, jälkiasemassa (<LessonLink n={2}>oppitunti 2</LessonLink>; rekisteristä lisää <LessonLink n={47}>oppitunnilla 47</LessonLink>).

<Example id="ex-5243158f1035" />

Tässä mies on tapettava eli päälauseen objekti, joten käytetään muotoja <Hv fi="miehen, joka …">lue vale</Hv>. Ja sitten kaunein esimerkki:

<Example id="ex-4e92c5cceb75" />

<Interlinear hv="Urnēt luo buzdaro tolvio belma pryjātās!" gloss="nähdä-PRS.2PL joka-GEN orja-GEN jokainen-GEN kahle-ACC.PL rikkoa-IMP.2PL" fi="Rikkokaa jokaisen näkemänne orjan kahleet!" />

Relatiivilauseessa orja on se, jonka näette (suomeksi *jonka*). Päälauseessa orja on kahleiden omistaja, siis genetiivissä, ja niin on myös <Hv l="lua">luo</Hv>. Suomi ja valyria valitsevat tässä samalle sanalle eri sijan, koska sija määräytyy eri lauseesta.

Muutama esimerkki lisää. Lue ne ja kysy itseltäsi joka kerta: mikä on pääsanan rooli päälauseessa?

<Example id="ex-17d0e4dba360" />

<Example id="ex-1097b2be36d2" />

<Example id="ex-93fc345af78b" />

Rhaenyra käyttää samaa rakennetta riidellessään Daemonin kanssa. Nyt pääsana on maasukuinen <Hv glossed>sombāzmion</Hv> ’linna’, joten muoto on <Hv>luon</Hv>:

<Example id="ex-e06ca061fb10" />

## Ilman pääsanaa: lȳ ja līr

Suomessa sanotaan *se, joka* ja *se, mitä*. Valyriassa tähän käytetään kahta <Term id="relatiivipronomini">relatiivipronominia</Term>, jotka ovat muodoltaan <Hv>lua</Hv>-sanan substantiivimuotoja:

- <Hv glossed>lȳ</Hv> tarkoittaa ’se joka, sellainen joka’, ja sitä käytetään konkreettisista, laskettavista asioista, myös ihmisistä.
- <Hv glossed>līr</Hv> tarkoittaa ’se mikä, se mitä’, ja sitä käytetään abstrakteista asioista ja ainesanoista.

Nekin tulevat relatiivilauseen perään ja saavat sijansa päälauseesta.

<Example id="ex-a21911c5c6c3" />

<Interlinear hv="Īlōn pryjassis līr īlōn mazverdis." gloss="me-ACC tuhota-AOR.3SG mikä-NOM me-ACC luoda-AOR.3SG" fi="Se, mikä tuhoaa meidät, luo meidät." />

Daemon kysyy Rhaenyralta:

<Line id="hotd-s1e05-001" />

Rhaenyran piikki Daemonille ja tämän vastaus näyttävät, että pronominin sija tulee edellisestä lauseesta. Rhaenyra sanoo, että Daemonilla on jo vaimo (akkusatiivi <Hv>ābrazȳri</Hv>). Daemon vastaa lyhyesti, ja <Hv l="lȳ">lī</Hv> on akkusatiivissa, koska se vastaa tuota objektia:

<Line id="hotd-s1e02-013" />

<Line id="hotd-s1e02-014" />

<Hv glossed>Lī</Hv> on monikäyttöinen muoto. Se on pronominin <Hv glossed>lȳ</Hv> akkusatiivi ja monikon nominatiivi (’ne, jotka’), mutta myös relatiiviadjektiivin <Hv>lua</Hv> aurinkosuvun akkusatiivi. Punainen pappi rukoilee sammuneen kynttilän puolesta:

<Line id="got-s6e02-002" />

<Note>
Repliikin alun *zȳhys perzys* on Petersonin mukaan ”uskottava puhujan virhe”: <Hv>stepagon</Hv>-verbin objektina sen pitäisi olla akkusatiivissa, <Hv fi="hänen tulensa">zȳhi perzi</Hv> (Petersonin Tumblr, 2016).
</Note>

Repliikin lopussa (<Hv glossed>morghūltas lī qēlītsos</Hv> ’kynttilä, joka on sammunut’) <Hv l="lua">lī</Hv> on taas etuasemassa ja akkusatiivissa, koska kynttilä (aurinkosukuinen <Hv>qēlītsos</Hv>) on objekti. Pelkästä sanasta ei siis näe, onko kyseessä adjektiivi vai pronomini. Katso, tuleeko sen perään substantiivi.

Vielä kaksi esimerkkiä. Daemonin julma lohdutus: *se, mikä äidillesi tapahtui, oli tragedia*. Verbi <Hv glossed>imassigon</Hv> ’tapahtua jollekulle’ on applikatiivi, joten se, jolle tapahtuu, on akkusatiivissa (<Hv fi="sinun äitisi">aōhe muñe</Hv>).

<Example id="ex-41f60b238f0c" />

Ja lohikäärmeenvartijoiden vanhimman vastaus Rhaenyralle. Siinä <Hv>luon</Hv> on pronominin tavoin ilman substantiivia: *sama, jonka valitsit*. Wiki ei kuvaa tätä sanajärjestystä (<Hv glossed>hēnkon luon</Hv>) erikseen. Se näkyy tässä repliikissä, ja palaamme siihen <LessonLink n={50}>oppitunnilla 50</LessonLink>.

<Example id="ex-8295f52fa9c2" />

## Ilman olla-verbiä

Jos relatiivilauseessa olisi vain *joka on X* (X on adjektiivi tai genetiivi), verbiä ei käytetä lainkaan. Silloin adjektiivi tai genetiivi määrittää pronominia suoraan.

<Example id="ex-56af41a285be" />

<Interlinear hv="Ñuhor līr gūrēnna." gloss="minun-AQ.ACC mikä-ACC ottaa-FUT.1SG" fi="Otan sen, mikä on minun." />

<Example id="ex-1ac36741e3f2" />

Suomessakin tehdään joskus samoin: *otan omani* tai *minun omani*. Valyriassa tämä on kuitenkin vakiintunut rakenne. Wikin taulukossa on myös <Hv glossed>Kastor līr ipradinna</Hv> ’syön sen, mikä on vihreää’ (<Hv glossed>kasta</Hv> tarkoittaa sekä sinistä että vihreää; valyria ei erota niitä).

## Kokoa itse

Seuraavat lauseet on rakennettu wikin mallien mukaan, ja niiden muodot on tarkistettu. Lue ensin valyriankielinen lause ja yritä kääntää se katsomatta suomennosta.

<Practice hv="Riñe ūndas lua taoba kirine issa." fi="Poika, joka näki tytön, on iloinen." />

<Practice hv="Riñe ūndas lue taobe rhēden." fi="Tunnen pojan, joka näki tytön." />

<Practice hv="Riñe ūndas luo taobo kepa kesīr ilza." fi="Tytön nähneen pojan isä on täällä." />

<Practice hv="Jaelā līr gīmin." fi="Tiedän, mitä haluat." />

Muista kolme sääntöä: relatiivilause tulee ensin, <Hv>lua</Hv> tulee sen jälkeen ja pääsana viimeisenä. <Hv>Lua</Hv> saa sijansa päälauseesta. Ilman pääsanaa käytä sanaa <Hv l="lȳ">lȳ</Hv> (konkreettinen) tai <Hv>līr</Hv> (abstrakti).

## Sidesanat: kunnes, koska, muuten, -ko

<LessonLink n={39}>Oppitunnilla 39</LessonLink> kävit läpi, milloin sivulauseen verbi on subjunktiivissa: ehtolauseet sanalla <Hv>lo</Hv>, tarkoituslauseet (<Hv>kessyt</Hv>) ja epäsuora esitys. Tämä oppitunti täydentää työkalupakkia sidesanoilla, joita tarvitsette, kun kerrotte toisillenne jotakin pidemmin: *kunnes*, *ennen kuin*, *koska*, *muuten*, *niin kuin*, *nyt kun*, *sen jälkeen kun* ja epäsuoran kysymyksen *-ko/-kö*.

Yksi asia kannattaa pitää mielessä koko ajan: **valyriassa ei ole *että*-sanaa**, ja sivulause on tavallisesti päälauseen verbin edellä. Lainattu lause voi kuitenkin tulla myös kokonaan ensin, jolloin puhuja mainitaan vasta pilkun jälkeen. Rhaenyra lainaa isäänsä juuri näin, ja lainauksessa on vielä relatiivilause (edellä, ”Relatiivilauseet”):

<Line id="hotd-s3e03-002" />

## Kunnes ja ennen kuin: iā

Sana <Hv glossed>iā</Hv> on Duolingosta tuttu merkityksessä ’tai’. Sanakirjan mukaan se tarkoittaa sivulauseen alussa myös ’kunnes, ellei’ ja ’ennen kuin’. Kaikissa esimerkeissä sivulauseen verbi on subjunktiivissa. Rhaenyra uhkaa Daemonia, ja tämä kuittaa:

<Line id="hotd-s1e02-010" />

<Interlinear hv="Iā sīlāvose iōrō, daor." gloss="ennen.kuin täysi-ikäinen olla-PRS.SBJV.2SG ei" fi="Ei ennen kuin tulet täysi-ikäiseksi." />

<Example id="ex-3f44463882b3" />

<Interlinear hv="Tubissa korzīlzi iā taoba giēnilus." gloss="päivä-NOM.PL venyä-FUT.3PL ennen.kuin poika-NOM parantua-FUT.SBJV.3SG" fi="Kestää päiviä, ennen kuin poika toipuu." />

Sanatarkasti *päivät venyvät, ennen kuin poika paranee*. Suomessa sanotaan *kestää päiviä*, valyriassa päivät itse venyvät. Sanakirjan huomautuksen mukaan <Hv fi="kunnes, ennen kuin">iā</Hv> voi olla molempien lauseiden alussa, ja Daemon tekee juuri niin:

<Example id="ex-a70ab1390279" />

Tässä vielä kirjeen loppuun sopiva lause (<LessonLink n={41}>oppitunti 41</LessonLink>):

<Example id="ex-dc8bd0596993" />

## Kunnes: vapār

Toinen samaa tarkoittava sana on <Hv l="vapār-2">vapār</Hv> (<Hv glossed>va</Hv> ’asti’ + <Hv glossed>pār</Hv> ’silloin’). Vertaa näitä kahta. Daenerys puhuu tulevasta tavoitteesta, ja verbi on subjunktiivissa (<Hv>dāerēdoty</Hv>). Rhaenyra puhuu tapahtuneesta tosiasiasta, ja verbi on indikatiivissa (<Hv>morghākotas</Hv>):

<Example id="ex-1053034e687f" />

<Example id="ex-ed03e5a708fb" />

Wiki ei esitä tästä sääntöä. Tämä on havainto, joka sopii yhteen Petersonin kuvaaman sävyeron kanssa (<LessonLink n={39}>oppitunti 39</LessonLink>): indikatiivi tarkoittaa *näin on*, subjunktiivi *näin olisi, näin pitäisi tulla*.

## Koska: kesrio syt, kejo syt, hen kejot

Syyn ilmaisee <Hv glossed>kesrio syt</Hv>, sanatarkasti ’tämän vuoksi’. Se aloittaa syylauseen, ja syylause voi olla päälauseen edellä tai jäljessä:

<Example id="ex-f1f5d97ace33" />

<Example id="ex-53ecade293a8" />

Sanakirjan mukaan <Hv fi="koska">kejo syt</Hv> on sama ilmaus toisessa muodossa ja <Hv fi="koska, sillä">hen kejot</Hv> sen synonyymi. Jälkimmäisen kuulet nuoren Rhaenyran suusta:

<Line id="hotd-s2e04-006" />

Sanakirjan esimerkissä <Hv glossed>hen kejot</Hv> on lauseen keskellä, aivan kuten suomen *sillä*:

<Example id="ex-89c24cc3b71b" />

Syylauseen lopussa on kielto <Hv>daor</Hv>, joten verbi on subjunktiivissa (<Hv>ulosy</Hv>, verbistä <Hv>ilagon</Hv>). Kieltosäännöt pätevät sivulauseissakin.

Kysymyssana <Hv glossed>skorȳso</Hv> ’miksi’ tarkoittaa myös ’koska’. Sanakirjan mukaan näin voi sanoa vain vastattaessa kysymykseen eli keskustelussa: *Miksi? – Koska…*

## Muuten, niin kuin, nyt kun

**<Hv glossed>Lodaor</Hv> ’jos ei, muuten’** on yhdyssana sanoista <Hv glossed>lo</Hv> ’jos’ ja <Hv glossed>daor</Hv> ’ei’. Daenerys uhkaa Yunkaita:

<Example id="ex-a634b9840da5" />

**<Hv glossed>Lo … sepār</Hv> ’niin kuin … niin’.** Sanakirjan mukaan <Hv glossed>lo</Hv> tarkoittaa myös ’aivan niin kuin’, ja <Hv l="sepār-2">sepār</Hv> vastaa sitä päälauseessa:

<Example id="ex-1a668ab27fbc" />

Punainen papitar käyttää pelkkää <Hv l="sepār-2">sepār</Hv>-sanaa samassa merkityksessä: <Hv glossed>Dārys rȳbis sepār dohaeriros rȳbis</Hv> ’hän kuulee kuninkaan niin kuin orjankin’.

**<Hv glossed>Lo sīr</Hv> ’nyt kun’.** Zanrush yllyttää Meereenin väkeä:

<Example id="ex-df3b8f72326b" />

**<Hv glossed>toliot</Hv> ’sen jälkeen kun’.** Postpositio <Hv glossed>toliot</Hv> ’yli’ tarkoittaa infinitiivin kanssa myös ’kun, sen jälkeen kun’. Daemonin neuvo on tuttu <LessonLink n={42}>oppitunnilta 42</LessonLink>:

<Line id="hotd-s1e04-004" />

Suomessa sama tehdään lauseenvastikkeella: *naimisiin mentyäsi*. Valyrian rakenteessa ei ole persoonaa lainkaan, vain passiivin infinitiivi ja postpositio.

## Epäsuora kysymys: lo + subjunktiivi

Wikin tapaluokkasivulla sanotaan vielä, ettei tiedetä, miten epäsuorat kysymykset muodostetaan. House of the Dragonin repliikeissä niitä kuitenkin on, ja ne ovat kaikki samaa mallia: <Hv glossed>lo</Hv> ’onko, -ko/-kö’ ja subjunktiivi. Kirurgi Laenan vuoteen ääressä:

<Example id="ex-78b8157db7c6" />

<Interlinear hv="Yn lo glaesos, sesīr sīlī ūī vestragon koston daor." gloss="mutta -ko elää-PRS.SBJV.3SG edes.nyt varmasti se-ACC sanoa-INF voida-PRS.SBJV.1SG ei" fi="Mutta en voi nytkään varmasti sanoa, elääkö se." />

Rhaenyra miettii veljeään, ja pääverbi <Hv glossed>pendan</Hv> ’mietin’ on aivan viimeisenä:

<Example id="ex-1d4fc04261b3" />

<Interlinear hv="Ñurho valonqro paghyro jēdunna, lo tolijī kepa ñuha kirimvī rhēdos pendan" gloss="minun-AQ.GEN pikkuveli-GEN henkäys-GEN.COL tunti-LOC.PC -ko vihdoin isä-NOM minun-NOM onni-ACC kohdata-PRF.SBJV.3SG miettiä-PRS.1SG" fi="Mietin, löysikö isäni vihdoin onnen niinä muutamina tunteina, jotka veljeni eli." />

<Hv glossed>Jēdunna</Hv> on lokatiivi sanasta <Hv glossed>jēdun</Hv> ’tunti’. Sana on alun perin sanan <Hv glossed>jēda</Hv> ’aika, kausi’ muutama-muoto, joka on itsenäistynyt omaksi sanakseen (muutaman johtaminen, <LessonLink n={35}>oppitunti 35</LessonLink>). Suomen *-ko/-kö*-liite hoitaa saman tehtävän kuin valyrian <Hv glossed>lo</Hv>: *elääkö se*, *löysikö isä onnen*. Ero on sijainnissa: suomessa liite on kysyttävässä sanassa, valyriassa <Hv glossed>lo</Hv> aloittaa koko lauseen.

<Note>
Sama <Hv glossed>lo</Hv> voi siis tarkoittaa ’jos’, ’kun’, ’niin kuin’ ja ’-ko’. Merkityksen erottaa näin: jos lauseen jälkeen tulee <Hv l="sepār-2">sepār</Hv> tai päälause, kyse on ehdosta tai vertauksesta. Jos lause on jonkin verbin, kuten *sanoa*, *tietää* tai *miettiä*, objekti, kyse on epäsuorasta kysymyksestä.
</Note>

## Kokoa itse

<Practice hv="Kirine iksan, kesrio syt kesīr ilā." fi="Olen iloinen, koska olet täällä." />

<Practice hv="Kesīr umbinna iā māzīlū." fi="Odotan täällä, kunnes tulet." />

<Practice hv="Lo kirine iksō, pendan." fi="Mietin, oletko iloinen." />

Kertaus: <Hv glossed>iā</Hv> ja <Hv l="vapār-2" glossed>vapār</Hv> tarkoittavat *kunnes* ja *ennen kuin*, <Hv glossed>kesrio syt</Hv> ja <Hv glossed>hen kejot</Hv> *koska*, <Hv glossed>lodaor</Hv> *muuten*, <Hv glossed>lo sīr</Hv> *nyt kun* ja <Hv glossed>lo</Hv> + subjunktiivi epäsuorassa kysymyksessä *-ko/-kö*.

## Sanat

<Vocab />

<Check />
